var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStackedColumn = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "40px",
  height: "30px",
  viewBox: "0 0 40 30",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  id: "background",
  stroke: "#CCCCCC",
  fill: "#FFFFFF",
  x: 0.5,
  y: 0.5,
  width: 39,
  height: 29,
  rx: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#37809f",
  transform: "scale(0.28, 0.24)",
  d: "m40 108h-17v-15h17zm0-41h-17v22h17zm25 5h-18v36h18zm0-30h-18v26h18zm24 56h-18v10h18zm-18-4h18v-76h-18zm25-6v20h17v-20zm0-31v27h17v-27z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgStackedColumn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/stacked_column.4c08624ee740d126ce69f7070e511705.svg";